<template>
  <div class="">
    <label v-if="label" class="mb-0 c-label" :class="labelClass">{{ label }} 
      <span v-if="required" style="font-size: 16px" class="text-danger font-weight-bold">*</span>
    </label>
    <div v-if="inputType === 'textarea'">
      <textarea 
        v-if="!iconSrc && id" 
        :id="`${id}`" 
        @focusin="setClass ? setClass(id) : ''" 
        @focusout="unsetClass ? unsetClass(id) : ''" 
        class="c-input" 
        :class="inputClass + (disabled ? 'bg-light-grey' : '')" 
        :style="inputStyle" 
        :value="value" 
        :placeholder="placeholder" 
        :type="type" 
        @input="$emit('input',$event.target.value)" 
        :maxlength="maxlength" 
        style="height:80px;" 
        :readonly="readonly" 
        :required="required"
        :disabled="disabled"
      ></textarea>
      <textarea 
        v-else-if="!iconSrc && !id" 
        @focusin="setClass ? setClass(id) : ''" 
        @focusout="unsetClass ? unsetClass(id) : ''" 
        class="c-input" 
        :class="inputClass + (disabled ? 'bg-light-grey' : '')" 
        :style="inputStyle" 
        :value="value" 
        :placeholder="placeholder" 
        :type="type" 
        @input="$emit('input',$event.target.value)" 
        :maxlength="maxlength" 
        style="height:80px;" 
        :readonly="readonly" 
        :required="required"
        :disabled="disabled"
      ></textarea>
      <div v-else>
        <textarea 
          v-if="id" 
          :id="`${id}`" 
          @focusin="setClass ? setClass(id) : ''" 
          @focusout="unsetClass ? unsetClass(id) : ''" 
          class="c-input" 
          :class="inputClass + (disabled ? 'bg-light-grey' : '')" 
          :style="inputStyle" 
          style="padding-right: 50px;height:50px;" 
          :value="value" 
          :placeholder="placeholder" 
          :type="type" 
          @input="$emit('input',$event.target.value)" 
          :maxlength="maxlength" 
          :readonly="readonly" 
          :required="required"
          :disabled="disabled"
        ></textarea>
        <textarea 
          v-else @focusin="setClass ? setClass(id) : ''" 
          @focusout="unsetClass ? unsetClass(id) : ''" 
          class="c-input" 
          :class="inputClass + (disabled ? 'bg-light-grey' : '')" 
          :style="inputStyle" 
          style="padding-right: 50px;height:50px;" 
          :value="value" 
          :placeholder="placeholder" 
          :type="type" 
          @input="$emit('input',$event.target.value)" 
          :maxlength="maxlength" 
          :readonly="readonly" 
          :required="required"
          :disabled="disabled"
        ></textarea>
        <img class="c-input-icon" :src="iconSrc">
      </div>
    </div>
    <div v-else>
      <div v-if="type === 'date'">
        <div class="date-picker-wrapper position-relative">
        <input
          class="c-input datepicker-masked"
          :value="formattedValue"
          :placeholder="placeholder"
          type="text"
          @input="onInput"
          @focus="isTyping = true"
          @blur="onBlur"
          :disabled="disabled"
          :class="inputClass"
          :required="required"
          :id="`${id}`" 
          @focusin="setClass ? setClass(id) : ''" 
          @focusout="unsetClass ? unsetClass(id) : ''" 
          :style="inputStyle" 
          style="padding-right: 50px" 
          :maxlength="maxlength" 
          :min="inputMin" 
          :step="inputStep" 
          :readonly="readonly" >
        <span class="calendar-icon" style="position: absolute; top: 21px; right: 10px; transform: translateY(-50%); cursor: pointer;">
          <i class="fa fa-calendar"></i>
        </span>
      </div>
      </div>
      <div v-else>
        <input 
        v-if="!iconSrc && id" 
        :id="`${id}`" 
        @focusin="setClass ? setClass(id) : ''" 
        @focusout="unsetClass ? unsetClass(id) : ''" 
        class="c-input" 
        :class="inputClass + (disabled ? 'bg-light-grey' : '')" 
        :style="inputStyle" 
        :value="value" 
        :placeholder="placeholder" 
        :type="type" 
        @input="$emit('input',$event.target.value)" 
        :maxlength="maxlength" 
        :min="inputMin" 
        :max="inputMax" 
        :step="inputStep" 
        :readonly="readonly" 
        :required="required"
        :disabled="disabled">
      <input 
        v-else-if="!iconSrc && !id" 
        @focusin="setClass ? setClass(id) : ''" 
        @focusout="unsetClass ? unsetClass(id) : ''" 
        @blur="$emit('blur', $event)"
        class="c-input" 
        :class="inputClass + (disabled ? 'bg-light-grey' : '')" 
        :style="inputStyle" 
        :value="value" 
        :placeholder="placeholder" 
        :type="type" 
        @input="$emit('input',$event.target.value)" 
        :maxlength="maxlength" 
        :min="inputMin" 
        :max="inputMax" 
        :step="inputStep" 
        :readonly="readonly" 
        :required="required"
        :disabled="disabled">
      <div v-else>
        <input 
          v-if="id" 
          :id="`${id}`" 
          @focusin="setClass ? setClass(id) : ''" 
          @focusout="unsetClass ? unsetClass(id) : ''" 
          class="c-input" 
          :class="inputClass + (disabled ? 'bg-light-grey' : '')" 
          :style="inputStyle" 
          style="padding-right: 50px" 
          :value="value" 
          :placeholder="placeholder" 
          :type="type" 
          @input="$emit('input',$event.target.value)" 
          :maxlength="maxlength" 
          :min="inputMin" 
          :max="inputMax" 
          :step="inputStep" 
          :readonly="readonly" 
          :required="required"
          :disabled="disabled">
        <input 
          v-else @focusin="setClass ? setClass(id) : ''" 
          @focusout="unsetClass ? unsetClass(id) : ''" 
          class="c-input" 
          :class="inputClass + (disabled ? 'bg-light-grey' : '')" 
          :style="inputStyle" 
          style="padding-right: 50px" :value="value" 
          :placeholder="placeholder" 
          :type="type" 
          @input="$emit('input',$event.target.value)" 
          :maxlength="maxlength" 
          :min="inputMin" 
          :max="inputMax" 
          :step="inputStep" 
          :readonly="readonly" 
          :required="required"
          :disabled="disabled">
        <img class="c-input-icon" :src="iconSrc">
      </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: [String, Number]
    },
    label: {
      type: String
    },
    placeholder: {
      type: String
    },
    type: {
      type: String
    },
    maxlength: {
      type: [String, Number]
    }, 
    iconSrc: {
      type: String
    },
    id: {
      type: String
    },
    setClass: {
      type: Function
    },
    unsetClass: {
      type: Function
    },
    inputType: {
      type: String
    },
    labelClass: {
      type: String,
      default: ''
    },
    inputClass: {
      type: String,
      default: ''
    },
    inputStyle: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    inputMin: {
      type: Number,
      default: undefined
    },
    inputMax: {
      type: Number,
      default: undefined
    },
    inputStep: {
      type: Number,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxYear:{
      default:null
    },
    minYear:{
      default:null
    },
    // Minimum selectable date (YYYY-MM-DD). Disables earlier dates in the
    // Flatpickr calendar and blocks earlier typed/picked values.
    minDate:{
      type: String,
      default: ''
    },
  },
  data() {
    return {
      isTyping:false,
    }
  },
  mounted(){
    if (window.initDatePickers) {
      window.initDatePickers();
      window.initDatePickers();
      window.initYearInputs()
      window.initClockInputs()
    }
    this.$nextTick(() => this.applyMinDate());
  },
  computed:{
    formattedValue() {
      if (!this.value) return ""
      if (/^\d{4}-\d{2}-\d{2}$/.test(this.value)) {
        const [year, month, day] = this.value.split("-")
        return `${month}/${day}/${year}`
      }
      return this.value
    },
  },
  watch:{
    
    isShort: function (val) {
      this.cbValue = val === 'true'
    },
    value(newVal) {
    if (this.isTyping) return;

    if (newVal && /^\d{4}-\d{2}-\d{2}$/.test(newVal)) {
      const [year, month, day] = newVal.split("-");
      this.inputValue = `${month}/${day}/${year}`;
    } else {
      this.inputValue = "";
    }
  },
    minDate() {
      this.applyMinDate();
    }
  },
  methods:{
    parseIsoDate(v) {
      if (!v || !/^\d{4}-\d{2}-\d{2}$/.test(v)) return null;
      const [y, m, d] = v.split("-").map(Number);
      return new Date(y, m - 1, d);
    },
    applyMinDate() {
      if (this.type !== 'date') return;
      const inputEl = this.$el.querySelector('.datepicker-masked');
      const fp = inputEl && inputEl._flatpickr;
      if (!fp) return;

      const min = this.parseIsoDate(this.minDate);
      fp.set('minDate', min || null);

      // Clear the current value if it falls before the new minimum date
      const current = this.parseIsoDate(this.value);
      if (min && current && current < min) {
        fp.clear();
        inputEl.value = '';
        this.$emit('input', '');
      }
    },
    onBlur() {
      const [mm, dd, yyyy] = this.inputValue?.split("/");
      if(this.inputValue == ""){
        this.$emit("input", this.inputValue);
      }else if (
        mm?.length === 2 &&
        dd?.length === 2 &&
        yyyy?.length === 4 &&
        /^\d+$/.test(mm + dd + yyyy) 
      ) {
        const formatted = `${yyyy}-${mm.padStart(2, "0")}-${dd.padStart(2, "0")}`;
        this.$emit("input", formatted);
      }

      this.isTyping = false;
    },
    onInput(event) {
      this.inputValue = event.target.value;

      const [mm, dd, yyyy] = this.inputValue.split("/");

      if (yyyy?.length > 4) return;



      if (this.maxYear && yyyy && yyyy.length === 4 && parseInt(yyyy) > this.maxYear) {
        //change the year to the maxYear
        this.inputValue = `${mm}/${dd}/${this.maxYear}`;
        event.target.value = this.inputValue;
      }else if(this.minYear && yyyy && yyyy.length === 4 && parseInt(yyyy) < this.minYear){
        //change the year to the minYear
        this.inputValue = `${mm}/${dd}/${this.minYear}`;
        event.target.value = this.inputValue;
      }else if(yyyy && yyyy.length === 4 && parseInt(yyyy) < '1900'){
        this.inputValue = `${mm}/${dd}/1900`;
        event.target.value = this.inputValue;
      }

      if (
        mm?.length === 2 &&
        dd?.length === 2 &&
        yyyy?.length === 4 &&
        /^\d+$/.test(mm + dd + yyyy)
      ) {
        this.isTyping = false;
        const formatted = `${yyyy}-${mm.padStart(2, "0")}-${dd.padStart(2, "0")}`;
        // this.$emit("input", formatted);
      }
    },
  }
}
</script>

<style scoped>
  .bg-light-grey {
    background: #F2F2F2;
  }

  .input-error, .input-error:focus  {
    border: 1px solid #D84F4F !important;
  }
</style>